export default function findBaseUrl(): string {
  const searchString = '/wc/configurator.js';
  let root = document.getRootNode() as HTMLElement;
  for (const script of root.querySelectorAll('script')) {
    const src = script.getAttribute('src');
    if (src?.endsWith(searchString)) {
      return src.slice(0, searchString.length * -1);
    }
  }
  return ''; // demo mode
}

// declare let __webpack_public_path__: string;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// __webpack_public_path__ = findBaseUrl() + '/wc/';